const GlobalStyles = {
  HorizontalFlex: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  VerticalFlex: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column"
  }
};

export default GlobalStyles;
